import React, { Component } from 'react';
import PropTypes from 'prop-types';
// import dotProp from 'dot-prop';
import { set, get, unset, has } from 'lodash';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './Form.scss';
import InputBase from './Input/Base';
import Link from '../Link';

class Form extends Component {
  static propTypes = {
    onSubmit: PropTypes.func,
    onValidSubmit: PropTypes.func,
    onInvalidSubmit: PropTypes.func,
    onChange: PropTypes.func,
    onInit: PropTypes.func,
    onCancel: PropTypes.func,
    onInputError: PropTypes.func,
    value: PropTypes.object,
    errors: PropTypes.object,
    submitButtonLabel: PropTypes.string,
    cancelButtonLabel: PropTypes.string,
    hideButtonContainer: PropTypes.bool,
    disabled: PropTypes.bool,
    isSubmitting: PropTypes.bool,
    metaData: PropTypes.object,
    className: PropTypes.string,
  };

  static defaultProps = {
    value: {},
    errors: {},
    disabled: false,
    isSubmitting: false,
    metaData: {},
    hideButtonContainer: false,
    submitButtonLabel: null,
    cancelButtonLabel: null,
    className: null,
    onSubmit: null,
    onValidSubmit: null,
    onInvalidSubmit: null,
    onChange: null,
    onInit: null,
    onCancel: null,
    onInputError: null,
  };

  static getParentName(node) {
    if (!node.props.parentName) {
      return '';
    }
    return node.props.parentName !== ''
      ? `${node.props.parentName}[${node.props.name}]`
      : node.props.name;
  }

  static dotSet(exp, value, scope) {
    const levels = exp.split('.');
    const maxLevel = levels.length - 1;
    let target = scope;
    levels.some((level, i) => {
      if (typeof level === 'undefined') {
        return true;
      }
      if (i === maxLevel) {
        target[level] = value;
      } else {
        const obj = target[level] || {};
        target[level] = obj;
        target = obj;
      }
      return true;
    });
  }

  constructor(...args) {
    super(...args);
    this.state = {
      isFormValid: false,
    };
    this.inputComponents = [];
    this.errors = Object.assign({}, this.props.errors);
    this.value = Object.assign({}, this.props.value);
    this.debug = false;
    this.onCancel = this.onCancel.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.componentsCache = null;
  }

  // UNSAFE_componentWillMount() {
  //   this.debug && console.log('form::UNSAFE_componentWillMount');
  //   this.inputComponents = [];
  //   this.errors = Object.assign({}, this.props.errors);
  //   this.value = Object.assign({}, this.props.value);
  // }

  componentDidMount() {
    this.log('form::componentDidMount');
    this.onInit(this.getValue(true));
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    // if (nextProps === this.props) {
    //   return;
    // }
    if (nextProps.errors) {
      this.errors = Object.assign({}, nextProps.errors);
    }
    if (nextProps.value) {
      this.value = Object.assign({}, nextProps.value);
    }
    const isFormValid = this.isValid(this.value);
    this.log('form::UNSAFE_componentWillReceiveProps', {
      errors: nextProps.errors,
      value: nextProps.value,
      isFormValid,
    });
    this.setState({ isFormValid });
  }

  componentDidUpdate() {
    this.log('form::componentDidUpdate');
    if (this.componentsCache !== this.getComponentsCacheKey()) {
      this.onInit(this.getValue(true));
    }
  }

  onSubmit(e) {
    e.preventDefault();
    const value = this.getValue(true);
    if (typeof this.props.onSubmit === 'function') {
      this.props.onSubmit({ value });
    }
    if (this.isValid(value) && typeof this.props.onValidSubmit === 'function') {
      this.props.onValidSubmit({ value: this.getTransformedValue() });
    } else if (typeof this.props.onInvalidSubmit === 'function') {
      this.props.onInvalidSubmit({
        value: this.getTransformedValue(),
        errors: this.getErrors(),
      });
    }
  }

  onChange(e) {
    this.log('form::OnChange', e);
    const isFormValid = this.isValid(this.getValue(false));
    this.setState({ isFormValid });
    if (typeof this.props.onChange === 'function') {
      this.props.onChange(
        Object.assign(e, {
          form: {
            value: this.getTransformedValue(),
            unTransformedValue: this.getValue(true),
            isValid: isFormValid,
          },
        }),
      );
    }
  }

  onInputError(e) {
    this.log('form::onInputError', e);
    const isFormValid = this.isValid(this.getValue(true));
    this.setState({ isFormValid });
    if (typeof this.props.onInputError === 'function') {
      // TODO: errors: this.getErrors()
      this.props.onInputError(
        Object.assign(e, {
          form: { value: this.getTransformedValue(), isValid: isFormValid },
        }),
      );
    }
  }

  onInit(e) {
    const isFormValid = this.isValid(e);
    this.setState({ isFormValid });
    this.componentsCache = this.getComponentsCacheKey();
    if (typeof this.props.onInit === 'function') {
      this.props.onInit({
        value: e,
        isValid: isFormValid,
        getQuery: this.getQueryObject(),
        target: this,
      });
    }
  }

  onCancel(e) {
    if (typeof this.props.onCancel === 'function') {
      this.props.onCancel(e);
    }
  }

  getComponentsCacheKey() {
    const componentNames = this.inputComponents.map(
      component => component.props.name,
    );
    return componentNames.sort().join('..');
  }

  getValue(applyFilters) {
    this.log('form::getValue');
    this.value = {};
    for (let i = 0; i < this.inputComponents.length; i += 1) {
      const component = this.inputComponents[i];
      // if (component.props.disabled !== true) {
      set(this.value, component.props.name, component.getValue(applyFilters));
      // }
    }
    return this.value;
  }

  getTransformedValue() {
    this.log('form::getTransformedValue');
    const value = {};
    for (let i = 0; i < this.inputComponents.length; i += 1) {
      const component = this.inputComponents[i];
      // if (component.props.disabled !== true) {
      const componentValue = component.getValue(true);
      set(
        value,
        component.props.name,
        component.valueTransformOut(componentValue),
      );
      // }
    }
    return value;
  }

  // used to build get query to populate form
  getQueryObject() {
    const queryObject = {};
    for (let i = 0; i < this.inputComponents.length; i += 1) {
      const component = this.inputComponents[i];
      if (component.subfieldsQuery()) {
        set(
          queryObject,
          component.props.name.replace(/\[\d+\]/g, ''), // remove array index from name
          component.subfieldsQuery(),
        );
      } else {
        set(
          queryObject,
          component.props.name.replace(/\[\d+\]/g, ''), // remove array index from name
          component.getValue(false),
        );
      }
    }
    return queryObject;
  }

  getErrors() {
    this.errors = {};
    for (let i = 0; i < this.inputComponents.length; i += 1) {
      const component = this.inputComponents[i];
      this.errors[component.props.name] = component.getErrors();
    }
    return this.errors;
  }

  log(...args) {
    if (this.debug) {
      console.log(...args);
    }
  }

  isValid(value) {
    let isValid = true;
    for (let i = 0; i < this.inputComponents.length; i += 1) {
      const component = this.inputComponents[i];
      const componentValue = get(value, component.props.name);
      this.log(
        'form::isValid::component',
        component.props.name,
        component.isValid(componentValue),
        'x',
        componentValue,
        'x',
        component.getValue(),
      );
      isValid = !component.isValid(componentValue) ? false : isValid;
    }
    this.log('form::isValid', value, isValid);
    return isValid;
  }

  attachInputComponent(component) {
    // this.log('form::attachInputComponent', component.props.name);
    this.inputComponents.push(component);
  }

  detachInputComponent(component) {
    // this.log('form::detachInputComponent');
    this.inputComponents = this.inputComponents.filter(
      element => element !== component,
    );
    if (this.value) {
      unset(this.value, component.props.name);
    }
    if (this.errors) {
      delete this.errors[component.props.name];
    }
  }

  recursivelyUpdateChildren(node) {
    return React.Children.map(node.props.children, child => {
      if (!React.isValidElement(child)) {
        return child;
      }

      let childProps = {};

      // console.log('recure', child.props.name, child.type, child.props.children);
      if (Object.prototype.isPrototypeOf.call(InputBase, child.type)) {
        // console.log('recure base');
        childProps = {
          onChange: this.onChange.bind(this),
          onError: this.onInputError.bind(this),
          attachInputComponent: this.attachInputComponent.bind(this),
          detachInputComponent: this.detachInputComponent.bind(this),
          parentName: Form.getParentName(node),
        };

        if (has(this.value, child.props.name)) {
          childProps.value = get(this.value, child.props.name);
        }

        if (this.errors[child.props.name]) {
          childProps.errors = this.errors[child.props.name];
        }
      } else {
        // console.log('recure NOT base');
        childProps.children = this.recursivelyUpdateChildren(child);
      }

      return React.cloneElement(child, childProps);
    });
  }

  render() {
    this.log('form::render');
    const childrenWithProps = this.recursivelyUpdateChildren(this);
    const cancelButtonLabel = this.props.cancelButtonLabel
      ? this.props.cancelButtonLabel
      : 'Cancel';
    const cancelButton =
      typeof this.props.onCancel === 'function' ? (
        <Link
          onClick={this.onCancel}
          className="form-m__btn form-m__btn--cancel"
        >
          {cancelButtonLabel}
        </Link>
      ) : null;
    const submitButtonLabel = this.props.submitButtonLabel
      ? this.props.submitButtonLabel
      : 'Submit';
    const loader = this.props.isSubmitting ? (
      <div className="spinner">
        <i className="fa fa-circle" aria-hidden="true" />
      </div>
    ) : null;

    return (
      <form
        onSubmit={this.onSubmit}
        className={this.props.className}
        style={{ position: 'relative' }}
      >
        {childrenWithProps}
        {this.props.hideButtonContainer ? null : (
          <div className="form-m__buttons">
            {cancelButton}
            <button
              className="form-m__btn form-m__btn--accept"
              disabled={
                !this.state.isFormValid ||
                this.props.disabled ||
                this.props.isSubmitting
              }
            >
              {loader}
              <span className="btn__label">{submitButtonLabel}</span>
            </button>
          </div>
        )}
      </form>
    );
  }
}

export default withStyles(s)(Form);



// WEBPACK FOOTER //
// ./src/components/Form/Form.js